import React, { useEffect, useState } from 'react';
import { DatePicker, Modal, Typography } from 'antd';
import dayjs from 'libs/dayjs';

// Modal que pide la fecha de término comprometida al armar la carta Gantt. Si la
// ODT ya la tiene, viene precargada y es opcional; si no, es obligatoria (el
// backend reparte las fechas de las tareas apoyándose en ella).
export default function EncenderGanttModal({
  open,
  fechaComprometidaActual = null,
  loading = false,
  onConfirmar,
  onCancelar,
}) {
  const [fecha, setFecha] = useState(null);

  useEffect(() => {
    if (open) setFecha(fechaComprometidaActual ? dayjs(fechaComprometidaActual) : null);
  }, [open, fechaComprometidaActual]);

  const puedeConfirmar = Boolean(fecha);

  return (
    <Modal
      open={open}
      title="Armar carta Gantt"
      okText="Armar carta Gantt"
      cancelText="Cancelar"
      confirmLoading={loading}
      okButtonProps={{ disabled: !puedeConfirmar }}
      onOk={() => onConfirmar?.(fecha ? fecha.format('YYYY-MM-DD') : null)}
      onCancel={onCancelar}
      destroyOnHidden
    >
      <Typography.Paragraph type="secondary">
        Elige la fecha en que te comprometes a terminar la ODT. Al armar la carta, las tareas se
        reparten automáticamente en el tiempo y después puedes ajustarlas arrastrando las barras.
      </Typography.Paragraph>
      <DatePicker
        value={fecha}
        onChange={setFecha}
        format="DD/MM/YYYY"
        placeholder="Fecha de término comprometida"
        style={{ width: '100%' }}
      />
    </Modal>
  );
}
